import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
  {
    q: "How far in advance should I order?",
    a: "We ask for at least 2 days' notice so every dish can be freshly prepared. For larger events, please reach out as early as possible.",
  },
  {
    q: "Do you deliver?",
    a: "Yes — we deliver around Mount Eden and surrounding Auckland suburbs. Let us know your location and we'll confirm availability.",
  },
  {
    q: "Can you cater for vegetarian guests?",
    a: "Absolutely. We offer a range of vegetarian options and can tailor platters to suit dietary requirements.",
  },
  {
    q: "Can you provide large corporate orders?",
    a: "Yes. We regularly cater office lunches, meetings and corporate functions with flexible packages for teams of any size.",
  },
  {
    q: "What is the minimum order?",
    a: "Our minimum order is NZ$80 for delivery.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="bg-cream py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-4">
        <span className="label-caps text-sage">FAQ</span>
        <h2 className="mt-4 font-serif text-4xl md:text-5xl text-ink leading-tight">
          Good to know
        </h2>
      </div>
      <div className="md:col-span-8">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-serif text-xl md:text-2xl text-ink hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-ink/65 leading-relaxed text-base pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
